import React from 'react';
// Asset Picker imports
import TextureItem from './textureItem';
import SoundItem from './soundItem';
// Game(kit) imports
import LibraryTypeEnum from '../../../../Game/Base/Library/Enums';
import LibraryManager from '../../../../Game/Base/Library/LibraryManager';
import AssetCategory from './Category';

class AssetPickerContainer extends React.Component {
    handlePickAsset = assetData => {
        const { onPickAsset } = this.props;
        onPickAsset(assetData);
    };

    getAssets = () => {
        const { type, currentAsset } = this.props;
        const list = [];
        let library = null;
        let assetComponent = null;

        switch (type) {
            case LibraryTypeEnum.TEXTURES: {
                library = LibraryManager.textures;
                assetComponent = TextureItem;
                break;
            }
            case LibraryTypeEnum.SOUNDS: {
                library = LibraryManager.sounds;
                assetComponent = SoundItem;
                break;
            }
            default: {
                return list;
            }
        }

        // Loop through categories
        for (let i = 0; i < library._categories.length; ++i) {
            const { title } = library._categories[i];

            list.push(<AssetCategory key={i} title={title} assets={library._categories[i]._items} currentAsset={currentAsset} AssetComponent={assetComponent} onPickAsset={this.handlePickAsset} />);
        }

        return list;
    };

    render = () => {
        const { position, size } = this.props;
        const assetsList = this.getAssets();

        return (
            <div className="asset-picker-container" style={{top: position.y, left: position.x, width: size.width, height: size.height}}>
                {assetsList}
            </div>
        );
    };
}

export default AssetPickerContainer;
